import { NotificationConstants } from './constants'

export const addNotification = (notification) => {
  return (dispatch) => {
    dispatch({
      type: NotificationConstants.ADD_NOTIFICATION,
      response: notification,
    })
  }
}

export const clearNotification = () => {
  return (dispatch) => {
    dispatch({
      type: NotificationConstants.DELETE_ALL_NOTIFICATIONS,
      response: {},
    })
  }
}
